module.exports = __webpack_public_path__ + "a1cb670bde4a2120e634b619cae63884.mp4";